import { OTP_LENGTH } from "../../../../constants/common";

export const validateMobile = (mobileNumber) => {
  if (mobileNumber.length === 10 && /^[0-9]{10}$/.test(mobileNumber)) {
    return true;
  }
  return false;
};

export const validateOtp = (otp) => {
  if (otp.length === OTP_LENGTH && /^[0-9]{4}$/.test(otp)) {
    return true;
  }
  return false;
};
